import { render, staticRenderFns } from "./BasicInputField.vue?vue&type=template&id=2a6ae644&scoped=true&"
import script from "./BasicInputField.vue?vue&type=script&lang=js&"
export * from "./BasicInputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ae644",
  null
  
)

export default component.exports